var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5281 21.5672H22.5V6.79692C22.5 6.26724 22.0828 5.83599 21.5438 5.84067C21.0141 5.84067 20.5875 6.26724 20.5875 6.79692V21.5672H15.75V11.2594C15.75 10.7297 15.3234 10.2985 14.7938 10.3032C14.2641 10.3032 13.8375 10.7297 13.8375 11.2594V21.5672H9V14.0719C9 13.5422 8.57813 13.111 8.04375 13.1157C7.51406 13.1157 7.0875 13.5422 7.0875 14.0719V21.5625H2.4375V1.86567C2.4375 1.33599 2.02031 0.909424 1.48125 0.909424C0.946875 0.909424 0.515625 1.34067 0.515625 1.87036V22.5282C0.529688 23.2688 1.18594 23.5219 1.47188 23.4844H22.5234C23.0531 23.4844 23.4797 23.0579 23.4797 22.5282C23.4844 21.9985 23.0625 21.5719 22.5281 21.5672Z",
    fill: "white",
    fillOpacity: 0.4,
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71871 9.33285C5.76559 9.33754 5.81715 9.33754 5.86871 9.33285C6.0234 9.31879 9.61871 8.94848 18.4734 4.32191L18.2625 5.18441C18.1359 5.70004 18.4593 6.2016 18.9656 6.34223C19.5234 6.49691 20.0109 6.09848 20.1234 5.6391L20.8968 2.46098C21.0656 1.71566 20.4328 1.33598 20.189 1.30316L16.9687 0.54379C16.4578 0.421915 15.9375 0.740665 15.8156 1.25629C15.6937 1.77191 16.0125 2.28754 16.5281 2.40941L17.55 2.65316C9.19215 7.01254 5.75621 7.42504 5.69059 7.43441C5.16559 7.48598 4.78121 7.95004 4.82809 8.47035C4.87028 8.9391 5.25465 9.30473 5.71871 9.33285Z",
    fill: "white",
    fillOpacity: 0.66,
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.390625
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrow);
export default __webpack_public_path__ + "static/media/grow.cb11ae874b596dec53c8474aa8f798e6.svg";
export { ForwardRef as ReactComponent };